var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Gongview_pag",staticStyle:{"margin":"0 auto"}},[_c('div',[_c('el-pagination',{attrs:{"hide-on-single-page":"","current-page":_vm.param.pageNum,"layout":"prev, pager, next, jumper","pager-count":11,"page-size":_vm.param.pageSize,"total":_vm.param.total},on:{"current-change":_vm.handleCurrentChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }